<template>
  <div class="errorGenericContainer">
    <div class="grid imgGrid">
      <img
        class="imgContainer"
        src="@/assets/images/mosquita_generic_error.png"
      />
      <p class="nunitoBold subheaderText mt-10">
        {{ $t(`${errorKey}`) }}
      </p>
      <i18n
        v-bind:path="errorSubKey"
        class="ralewayRegular subheaderText2 mt-5"
        tag="p"
      >
        <a
          v-for="item in errorSubKeyParams"
          :key="item.key"
          v-bind:href="item.link"
          >{{ $t(item.key) }}
        </a>
      </i18n>
    </div>

    <div class="grid mt-10">
      <div class="stButton registerButton">
        <div class="stButtonCaption nunitoBold" v-on:click="goBack">
          {{ $t('k_continue_title') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      email: '',
      confirmMessage: '',
      error: null,
      defaultErrorImage: '@/assets/images/mosquita_generic_error.png'
    }
  },
  computed: {
    ...mapState({
      errorKey: state => state.errorKey,
      errorSubKey: state => state.errorSubKey,
      errorSubKeyParams: state => state.errorSubKeyParams,
      errorImage: state => state.errorImage,
      redirect: state => state.redirect
    })
  },
  methods: {
    async goBack() {
      await this.$store.dispatch('cleanError')
      if (this.redirect)
        this.$router.replace({ path: this.redirect, query: this.$route.query })
      else this.$router.go(-1)
    },
    getImgError() {
      if (this.errorImage) {
        return require(`${this.errorImage}`)
      } else return this.defaultErrorImage
    }
  }
}
</script>
<style lang="scss">
.errorGenericContainer {
  .registerButton {
    grid-row: 1;
    grid-column: 2/12;
    padding: 10px 0px;
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .buttonCaption {
    grid-row: 1;
    grid-column: 4/13;
    display: flex;
    font-size: 1.1875em;
  }

  .stButtonCaption {
    grid-row: 1;
    grid-column: 1/13;
    font-size: 1.1875em;
  }

  .formContainer {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
  }

  .formElement {
    grid-column: 2/12;
  }

  .formInputLabel {
    display: flex;
    font-size: 1em;
    color: var(--formColor);
  }
  .formInput {
    padding: 10px 15px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--outlineInput);
    font-size: 1em;
    color: var(--formColor);
  }

  .checkboxLabel {
    font-size: 0.688em;
    color: var(--formColor);
    grid-column: 3/8;
  }

  .accept {
    display: flex;
    grid-column: 2/3;
    align-self: center;
  }
  @media screen and (min-width: 620px) {
  }
  /* large tablet and laptop styles */
  @media screen and (min-width: 960px) {
  }
  /* desktop styles */
  @media screen and (min-width: 1200px) {
  }
}
</style>
